class Integracao{
  constructor(){
    this.id = null;
    this.token = '';
    this.dataVigenciaInicial = '';
    this.dataVigenciaFinal = '';
    //JOINS
    this.idCliente = null;
    this.idUsuario = null;
  }
}

export default Integracao;